import { Component, OnInit } from '@angular/core';
import {Input} from "@angular/core";

@Component({
  selector: 'breadcrumbs',
  templateUrl: './breadcrumbs.component.html'
})
export class BreadcrumbsComponent implements OnInit {
    @Input() breadcrumbs: Object[];

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/_blocks/breadcrumbs/breadcrumbs.component.ts